// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3RCZa","header":"Messages_header__1TE8S"};